import HTTP from '../common/http-common';
const END_POINT = '/job';

const listJobInsurance = (id) => HTTP.get(END_POINT + "/list-job-insurance/" + id);

const saveJobInsurance = (jobId, data) => HTTP.post(END_POINT + "/save-job-insurance/" + jobId , data);


export {
    listJobInsurance,
    saveJobInsurance
}